import type { ProjectFile } from "src/api/projectFolders/types";
import type { ProcessingStatusData } from "src/views/datasets/types";

// SDR processing_status values that mean the file is done and searchable
// (matches the backend's SEARCHABLE_PROCESSING_STATUSES gating the agent mount).
export const INDEXED_STATUSES = new Set(["completed", "no_processing_needed"]);
// Anything matching this is a terminal failure / stuck state needing reprocess.
export const FAILURE_STATUS = /fail|cancelled|orphan/;

// Chip fallback from the listing's SDR status until the status query knows
// the file, so a fresh upload's row can't read as ready (MRE#29777).
export const resolveRowStatus = (
  file: ProjectFile,
  statusByName: Record<string, ProcessingStatusData>,
): ProcessingStatusData | null => {
  const live = statusByName[file.name];
  if (live) return live;
  const status = (file.processing_status ?? "").toLowerCase();
  if (!status || file.sdr_id == null) return null;
  if (INDEXED_STATUSES.has(status)) return null;
  const failed = FAILURE_STATUS.test(status);
  return {
    source_data_record_id: file.sdr_id,
    dataset_id: 0,
    filename: file.name,
    status,
    // Failures need the "failed" prefix ("ocr_failed" etc. wouldn't match);
    // in-flight stages despace so the chip's space-keyed labels apply.
    display_status: failed ? "Failed" : status.replace(/_/g, " "),
    is_processing: !failed,
    error_message: null,
    progress_percentage: 0,
    num_chunks: 0,
    num_chunks_embedded: 0,
    uploaded_at: null,
    last_updated: null,
  };
};
